import { FormattedMessage } from 'react-intl'

import useExpiryDateCountdown from 'app/hooks/useExpiryDateCountdown'

interface FormattedEndDateProps {
  endDate: string | Date
}

const FormattedEndDate: RFC<FormattedEndDateProps> = ({ endDate }) => {
  const [days, hours, minutes] = useExpiryDateCountdown(endDate)

  return (
    <FormattedMessage
      defaultMessage="{days} days, {hours} hours, {minutes} minutes"
      values={{ days, hours, minutes }}
    />
  )
}

export default FormattedEndDate
